export default __webpack_public_path__ + "static/media/dani_xl.94512c6e.jpg";